
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"87","height":"69","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.886 44.045c6.42 0 11.625-4.273 11.625-9.545s-5.205-9.545-11.625-9.545-11.624 4.273-11.624 9.545 5.204 9.545 11.624 9.545zM61.982 44.045c6.42 0 11.624-4.273 11.624-9.545s-5.204-9.545-11.624-9.545c-6.42 0-11.625 4.273-11.625 9.545s5.205 9.545 11.625 9.545zM39.723 33.406c4.212-2.24 7.044 0 7.044 0M78.334 42.688l-2.37-2.28M8.334 42.688l2.37-2.28","stroke":"#333","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round"}})])
          )
        }
      }
    